import { ActionList, Button, Popover } from '@shopify/polaris';
import { useState } from 'react';
import { ExportModal } from './ExportModal';

// Modos soportados por el `ExportModal`. El label es el texto del menú
// desplegable; el modal mismo se encarga de los campos específicos
// (capítulos / orden de series / nada en Excel).
const MODES = [
  { kind: 'analisis', label: 'PDF Análisis' },
  { kind: 'series', label: 'PDF por Series' },
  { kind: 'excel', label: 'Excel' },
];

/**
 * Dropdown "Exportar" del header del report. Cada opción abre el
 * `ExportModal` en el modo correspondiente — el modal pide título /
 * subtítulo / filename + opciones específicas, y dispara la descarga
 * al hacer click en "Exportar".
 */
export const ExportMenu = ({ disabled, exportParamsArgs }) => {
  const [open, setOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);

  const handleSelect = (kind) => {
    setOpen(false);
    setModalMode(kind);
  };

  return (
    <>
      <Popover
        active={open}
        activator={
          <Button onClick={() => setOpen((s) => !s)} disclosure disabled={disabled}>
            Exportar
          </Button>
        }
        onClose={() => setOpen(false)}
        preferredAlignment="right"
      >
        <ActionList
          items={MODES.map((m) => ({ content: m.label, onAction: () => handleSelect(m.kind) }))}
        />
      </Popover>
      <ExportModal
        open={modalMode !== null}
        mode={modalMode}
        onClose={() => setModalMode(null)}
        exportParamsArgs={exportParamsArgs}
      />
    </>
  );
};
